import { pollWrapper } from 'poll-js';
type PollingConfig = {
  readonly pollingFunction: (arg0: any) => Promise<any>;
  readonly onResponse: (arg0: any) => any;
  readonly shouldPollAgain: (arg0: any) => boolean;
  readonly delay?: number;
  // in milliseconds
  readonly timeout?: number; // in milliseconds
};

function asyncPolling(config: PollingConfig): Promise<any> {
  const startOfPoll = new Date();
  const timeout: number = config.timeout || 120000; // 2min

  const { future } = pollWrapper({
    request: () => config.pollingFunction(undefined),
    pollingPeriod: config.delay,
    shouldStop: (response) => {
      const pollDuration = Date.now() - startOfPoll.getTime();

      if (pollDuration > timeout) {
        throw new Error('Request timeout');
      }

      return !config.shouldPollAgain(response);
    },
  });
  return future.then((response) => config.onResponse(response));
}

export { asyncPolling };
